import React from "react";

export default function LicensePlanTabs({
  activeTab,
  setActiveTab,
}) {
  const ORANGE = "#F7941D";
  const BLACK = "#000000";
  const WHITE = "#FFFFFF";

  const tabs = ["Device Licenses", "AI Credit Plans"];

  const containerStyle = {
    width: "50%",
    display: "flex",
    gap: 18,
  };

  const tabStyle = (isActive) => ({
    flex: 1,
    height: 50,
    borderRadius: 999,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    userSelect: "none",
    backgroundColor: isActive ? ORANGE : BLACK,
    border: isActive ? "3px solid ${ORANGE}" : `3px solid ${ORANGE}`,
    boxShadow: isActive ? "0 10px 24px rgba(247,148,29,0.25)" : "none",
    transition: "all 0.2s ease",
  });

  const textStyle = {
    color: WHITE,
    fontSize: 20,
    fontWeight: 800,
    fontFamily: "Inter, system-ui, sans-serif",
    letterSpacing: 0.3,
  };

  return (
    <div style={containerStyle} role="tablist">
      {tabs.map((tab) => {
        const isActive = activeTab === tab;

        return (
          <div
            key={tab}
            role="tab"
            aria-selected={isActive}
            onClick={() => setActiveTab(tab)}
            style={tabStyle(isActive)}
            onMouseDown={(e) => (e.currentTarget.style.transform = "scale(0.98)")}
            onMouseUp={(e) => (e.currentTarget.style.transform = "scale(1)")}
            onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
          >
            <span style={textStyle}>{tab}</span>
          </div>
        );
      })}
    </div>
  );
}
